<script setup>
import ContentHeader from "@/components/Dashboard/ContentHeader.vue";
import FilterOptions from "@/components/Dashboard/Devices/FilterOptions.vue";
import FilteredDevices from "@/components/Dashboard/Devices/totalDevices/FilteredDevices.vue";
</script>
<template>
  <ContentHeader :name="'Devices'" />
  <FilterOptions />
  <FilteredDevices />
</template>
